import {SignUpComponent} from "../SignUpComponent.js";
import {addMarketingYn, getUser, getUserInfo, isGuestUser, isSnsSignUp} from "../../store.js";
import {SignUpViewChanger} from "../../util/view-changer/index.js";
import {LoadingPopup} from "./LoadingPopup.js";
import {ERROR_CODE} from "../../constant.js";


export class TermPopup extends SignUpComponent {

    template() {
        return `
               <section id="popDimmed" class="agree-mini-pop" style="display: flex">
                 <article id="popMainLayer">
                      <header>
                        <h3>약관 동의</h3>
                        <button id="popupCancelBtn" ><i class="sign-icons-close"></i></button>
                      </header>
                      <div class="pop-cont">
                        <ul>
                          <li id="allCheckBtnLayer" class="js-check-input-layer">
                            <input type="checkbox"  id="allCheckBtn" class="" ><label for="allCheckBtn"></label><span>${i18next.t(login.agreeAll)}</span>
                          </li>
                          <li class="js-check-input-layer">
                            <input type="checkbox" class="js-check-input js-required" id="02"><label for="02"></label><span><em>(${i18next.t(login.required)})</em> ${i18next.t(login.termsOfUse)}</span><i data-link = "/terms.act" class="sign-icons-arrow-mini js-move-page"></i>
                          </li>
                          <li class="js-check-input-layer">
                            <input type="checkbox" class="js-check-input js-required"  id="03"><label for="03"></label><span><em>(${i18next.t(login.required)})</em>${i18next.t(login.privacyPolicy)}</span><i data-link = "/privacy.act" class="sign-icons-arrow-mini js-move-page"></i>
                          </li>
                          <li class="js-check-input-layer">
                            <input type="checkbox" class="js-check-input js-required" id="04"><label for="04"></label><span><em>(${i18next.t(login.required)})</em> ${i18next.t(common.overAged)}</span>
                          </li>
                          <li class="js-check-input-layer">
                            <input type="checkbox" class="js-check-input" id="marketingTerm"><label for="marketingTerm"></label><span>(${i18next.t(login.option)}) ${i18next.t(login.marketingConsent)}</span><i  data-link = "/terms_marketing.act " class="sign-icons-arrow-mini js-move-page"></i>
                          </li>
                        </ul>
                        <button id="moveCompanyJoinBtn" class="inactive">${i18next.t(common.confirm)}</button>
                      </div>
                </article>
            </section>
        `
    }

    setEvent() {
        this.addEvent("click", "#popDimmed", (e) => {
            const isPopMainLayer = $(e.target).closest("#popMainLayer").length > 0;
            if (isPopMainLayer) {
                return;
            }
            this.removePopup();
        });

        this.addEvent("click.prevent", ".js-check-input-layer", this.clickEventHandlerOfInputLayer.bind(this));

        this.addEvent("click", "#popupCancelBtn", this.removePopup.bind(this));

        this.addEvent("click", "#moveCompanyJoinBtn", this.clickEventHandlerOfJoinBtn.bind(this));
    }

    async clickEventHandlerOfJoinBtn() {
        if (this.existOfUncheckedRequiredInput()) {
            Mutil.mlog("필수 항목이 모두 체크되지 않았습니다.");
            return;
        }
        const marketingYn = $("#marketingTerm").prop("checked") ? 'Y' : 'N';
        addMarketingYn(marketingYn);
        if (isGuestUser()) {
            await this.getGuestRegister();
            return;
        }
        SignUpViewChanger.loadCompanyInviteView();
    }

    clickEventHandlerOfInputLayer(e) {
        const isArrowIcon = $(e.target).closest(".js-move-page").length > 0;
        if (isArrowIcon) {
            this.movePageBtnClickEvent(e);
            return;
        }

        const isAllCheckButton = $(e.target).closest("#allCheckBtnLayer").length > 0;
        isAllCheckButton ?  this.toggleAllCheckBtn(e) : this.checkInputClickEvent(e);
        this.toggleActiveJoinButton();
    }

    removePopup() {
        const $popup = $("#popDimmed");
        $popup.off().find("*").off();
        $("#popDimmed").remove();
    }

    moveTermsPage($movePageBtn) {
        if ($movePageBtn.length === 0) {
            return;
        }
        const pageUrl = Mutil.n2v($movePageBtn.data("link"));
        if (Mutil.empty(pageUrl)) {
            Mutil.mlog("이동할 약관 페이지 URL 정보가 없습니다. ")
            return;
        }
        Mutil.open(pageUrl, "_blank");
    }

    checkTermsInput($checkInput) {
        if ($checkInput.length === 0) {
            return;
        }
        const $allCheckBtn = $("#allCheckBtn");
        const isCheck = $checkInput.prop("checked");
        if (!isCheck) {
            $checkInput.prop("checked", true);
            this.isAllCheck() && $allCheckBtn.prop("checked", true);
            return
        }
        $checkInput.prop("checked", false);
        $allCheckBtn.prop("checked", false);
    }


    checkInputClickEvent(e) {
        const $checkInputLayer = $(e.target).closest(".js-check-input-layer")
        const $checkInput = $checkInputLayer.find(".js-check-input");
        this.checkTermsInput($checkInput);
    }

    toggleActiveJoinButton() {
        const $joinButton = $("#moveCompanyJoinBtn");
        if (this.existOfUncheckedRequiredInput()) {
            !$joinButton.hasClass("inactive") && $joinButton.addClass("inactive");
            return;
        }
        $joinButton.hasClass("inactive") && $joinButton.removeClass("inactive");
    }

    movePageBtnClickEvent(e) {
        const $movePageBtn = $(e.target).closest(".js-move-page");
        this.moveTermsPage($movePageBtn);
    }

    async getGuestRegister() {
        Mutil.mlog(getUserInfo());
        new LoadingPopup($("body"), {});
        if (isSnsSignUp()) {
            getUser().registerGuestBySnS();
            return;
        }

        const {ERR_CD = "", PASS_JSON = {}} = await getUser().registerGuest();
        const isSuccess = Mutil.n2v(ERR_CD) === ERROR_CODE.SUCCESS;
        if (!isSuccess) {
            SignUpViewChanger.loadGuestEmailView();
            return;
        }

        const CommonLogin = Mutil.requireIIFE("CommonLogin");
        CommonLogin.goLogin({
            ...PASS_JSON
        });
    }

    existOfUncheckedRequiredInput() {
        const $termsPopup = $("#popDimmed");
        const $requiredInputs = $termsPopup.find(".js-required");
        const unCheckedRequiredInput = Array.from($requiredInputs).filter(requiredInput => !$(requiredInput).prop("checked"));
        return unCheckedRequiredInput.length > 0;
    }

    isAllCheck() {
        const $termsPopup = $("#popDimmed");
        const $checkInput = $termsPopup.find(".js-check-input");
        const unCheckedInputs = Array.from($checkInput).filter(requiredInput => !$(requiredInput).prop("checked"));
        return unCheckedInputs.length === 0;
    }

    toggleAllCheckBtn() {
        const $allCheckBtn = $("#allCheckBtn");
        const $joinCheckInputs = $("#popDimmed").find(".js-check-input");
        if ($allCheckBtn.prop("checked")) {
            $allCheckBtn.prop("checked", false);
            $joinCheckInputs.prop("checked", false);
            return;
        }
        $allCheckBtn.prop("checked", true);
        $joinCheckInputs.prop("checked", true)

    }
}